<template>
  <div class="pis-pending">
    <div class="subpage-header">
      <h2 class="normal">{{ $t('thankYou.pending.header') }}</h2>
    </div>
    <p>{{ $t('thankYou.pending.description') }}</p>
  </div>
</template>

<script>
export default {
  name: 'ThankYouPending'
}
</script>
